import { BaseAssertException } from '../exceptions/base-assert.exception';
import { IllegalArgumentException } from '../exceptions/illegal-argument.exception';
import { Matcher } from '../matchers/base.matcher';
import { Constructor } from '../types/constructor.type';
import { argument } from './argument.assert';
import { hasText } from './has-text.assert';
import { isDefined } from './is-defined.assert';
import { isInstanceOf } from './is-instance-of.assert';
import { nonNullable } from './non-nullable.assert';
import { notEmpty } from './not-empty.assert';
import { notUndefined } from './not-undefined.assert';
import { state } from './state.assert';

export class Assert {
  public static hasText(
    value: string | null | undefined,
    message: () => string = () => 'value must have text',
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<string> {
    hasText(value, message, construct);
  }

  public static isDefined<T>(
    value: T,
    message: () => string = () => 'value must be defined',
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<T> {
    isDefined(value, message, construct);
  }

  public static isInstanceOf<T>(
    clazz: Constructor<T>,
    value: T,
    message: () => string = () => `value is not instance of ${clazz.name}`,
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<T> {
    isInstanceOf(clazz, value, message, construct);
  }

  public static nonNullable<T>(
    value: T | undefined | null,
    message: () => string = () => 'value must be defined',
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<T> {
    nonNullable(value, message, construct);
  }

  public static notEmpty<T extends unknown[] | string = unknown[]>(
    value: T | undefined | null,
    message: () => string = () => 'value is empty',
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<T> {
    notEmpty(value, message, construct);
  }

  public static state<T>(value: T, matcher: Matcher<T>): asserts value is NonNullable<T> {
    state(value, matcher);
  }

  public static argument<T>(value: T, matcher: Matcher<T>): asserts value is NonNullable<T> {
    argument(value, matcher);
  }

  public static notUndefined<T>(
    value: T | undefined | null,
    message: () => string = () => 'value must be defined or null',
    construct: new (message: string) => BaseAssertException = IllegalArgumentException,
  ): asserts value is NonNullable<T> {
    notUndefined(value, message, construct);
  }
}
